// Page
export const COMPONENT_TREE_ITEMS = 'componentTreeItems';
export const COMPONENT_TREE_ITEM_NAMES = 'componentTreeItemNames';
export const GET_COMPONENT_TREE_ITEM = 'getComponentTreeItem';
